module.exports = __webpack_public_path__ + "img/intro text_uk.842d2ce2.svg";